module.exports = __webpack_public_path__ + "img/audio-on2.1a93378a.svg";